import React from "react";
import { View, StyleSheet } from "react-native";
import { Text } from "components";

import { colors, sizes } from "assets/constants";
import { mq } from "utils";

export default function AlertDashedBox(props: { text: string }) {
  return (
    <View style={styles.alertDashedBox}>
      <Text
        style={{
          marginRight: sizes.space / 2,
          lineHeight: mq(23),
        }}
        size={"sm"}
      >
        {props.text}
      </Text>
    </View>
  );
}
const styles = StyleSheet.create({
  alertDashedBox: {
    padding: mq(7),
    borderWidth: 1,
    borderStyle: "dashed",
    borderRadius: sizes.radius.md,
    borderColor: colors.textColorGray,
    backgroundColor: colors.lightButtons,
  },
});
